// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3E-Sh","title":"Images45_title__3MRBK","images":"Images45_images__Zifx4"};